import { StoryblokBulletListItem } from './StoryblokBulletListItem'

export default StoryblokBulletListItem
